export const initialState = {
  showMessage: null,
};
